<template>
  <div class="rt-header">
    <slot />
    <transition name="rt-slide-fade">
      <div v-show="state.showMore"><slot name="extra" /></div>
    </transition>
  </div>
</template>

<script>
import { store } from '../table/store';
export default {
  name: 'RtHeader',
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    autoBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      state: store.state
    };
  },
  methods: {
    back() {
      if (this.autoBack) {
        this.$route.back();
        return;
      }
      this.$emit('back');
    }
  }
};
</script>

<style lang="less">
.rt-slide-fade-enter-active,
.rt-slide-fade-leave-active {
  transition: all 0.3s ease;
}
.rt-slide-fade-enter,
.rt-slide-fade-leave-to {
  transform: translateY(-40px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// rtHeader.vue?d1ee2b9c